import React from "react";
import { MoonIcon } from "@heroicons/react/outline";

export default function HeaderBanner(userData) {
  return (
    <>
      {userData.user.hasOwnProperty("status") && !userData.user.status && (
        <div className="bg-yellow-500">
          <div className="container  mx-auto px-4 sm:px-2 py-3">
            <div className="flex items-center justify-between flex-wrap">
              <div className="w-0 flex-1 flex items-center">
                <span className="flex p-2 rounded-lg bg-yellow-600">
                  <MoonIcon className="h-6 w-6 text-white" aria-hidden="true" />
                </span>
                <p className="ml-3 font-medium text-white truncate">
                  <span className="md:hidden">Your profile is in review</span>
                  <span className="hidden md:inline">
                    Your mentor profile is pending approval
                  </span>
                </p>
              </div>
              <div className="w-1/3 order-3 items-center mt-2 flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
                <a
                  href="/faq"
                  className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-yellow-700 bg-white hover:bg-yellow-50"
                >
                  Learn more
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
